import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import Container from 'src/components/atoms/Container';
import Heading from 'src/components/atoms/Heading/Heading';
import { StorefrontTypeSelect } from 'src/components/molecules/StorefrontTypeSelect/StorefrontTypeSelect';
import { SmartTitleCard } from 'src/components/organisms/SmartTitleCard/SmartTitleCard';
import { ScopeEnum } from 'src/domain';
import { useScope } from 'src/hooks';
import { HeatMapTypeEnum } from 'src/mapping/projected-option-count.mapping';
import { ProjectedOptionCountHeatMapTable } from './ProjectedOptionCountHeatMapTable';

export const ProjectedOptionCount: FC = () => {
    const scope = useScope();
    return (
        <Stack
            spacing={2}
            sx={{
                height: '100%',
            }}
        >
            <SmartTitleCard />
            <Container>
                <Stack
                    sx={{
                        gap: '2rem',
                    }}
                >
                    <Stack
                        direction="row"
                        sx={{
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Heading>Projected option count</Heading>
                        {scope !== ScopeEnum.STORE && <StorefrontTypeSelect />}
                    </Stack>
                    <Accordion disableGutters>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="projected-option-count-style-category-header"
                            aria-controls="projected-option-count-style-category-content"
                        >
                            <Typography variant="subtitle1">By style category</Typography>
                        </AccordionSummary>
                        <AccordionDetails id="projected-option-count-style-category-content">
                            <ProjectedOptionCountHeatMapTable type={HeatMapTypeEnum.Category} />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion disableGutters>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="projected-option-count-furniture-header"
                            aria-controls="projected-option-count-furniture-content"
                        >
                            <Typography variant="subtitle1">By furniture</Typography>
                        </AccordionSummary>
                        <AccordionDetails id="projected-option-count-furniture-content">
                            <ProjectedOptionCountHeatMapTable type={HeatMapTypeEnum.Furniture} />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion disableGutters>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="projected-option-count-furniture-zone-header"
                            aria-controls="projected-option-count-furniture-zone-content"
                        >
                            <Typography variant="subtitle1">By furniture zone</Typography>
                        </AccordionSummary>
                        <AccordionDetails id="projected-option-count-furniture-zone-content">
                            <ProjectedOptionCountHeatMapTable type={HeatMapTypeEnum.Zone} />
                        </AccordionDetails>
                    </Accordion>
                </Stack>
            </Container>
        </Stack>
    );
};
